import React, { Component } from "react";
import {
  Breadcrumb,
  PageHeader
  } from "react-bootstrap";

export default class Admin extends Component {
  constructor(props) {
	super(props);
	this.state = {
	  isLoading: false,
	  name: ''
	};
  }
  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  render() {
    return (
	  <div className="Admin">
	  <Breadcrumb>
	    <Breadcrumb.Item href="/">Inicio</Breadcrumb.Item>
        <Breadcrumb.Item active>Administración</Breadcrumb.Item>
	  </Breadcrumb>
	  <PageHeader>
	    Administración de Condominios
	  </PageHeader>
      <center><h2>En construcción!</h2></center>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/Admin.js